import { render, staticRenderFns } from "./PlayerTagger.vue?vue&type=template&id=6450cea0&"
import script from "./PlayerTagger.vue?vue&type=script&lang=ts&"
export * from "./PlayerTagger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports